// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"486":"60f916c0","555":"bf37f617","718":"e21390ae","836":"878e994d"}[chunkId] + ".css";
};